import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useCallback, useEffect } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { i18n } from '../../i18n/translate.js';
import { FAIcon } from '../fa-icon/component.js';
import { WindowHelperWrapper } from '../../utils/WindowHelper.js';
var DROPDOWN_KEY = 'language-dropdown';
var LanguageDropdown = function LanguageDropdown(_ref) {
  var languages = _ref.languages,
    locale = _ref.locale,
    locales = _ref.locales,
    reloadType = _ref.reloadType;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    dropdowns = _useState2[0],
    setDropdowns = _useState2[1];
  var getAvailableLangs = useCallback(function () {
    if (!languages) return [];

    // all currently compiled languages
    var langs = Object.entries(languages).reduce(function (acc, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      return [].concat(_toConsumableArray(acc), [{
        name: value,
        abbr: key
      }]);
    }, []);

    // user's available languages from full list
    return langs.filter(function (lng) {
      return locales.includes(lng.abbr);
    });
  }, [languages, locales]);
  var _useState3 = useState(getAvailableLangs()),
    _useState4 = _slicedToArray(_useState3, 2),
    availableLanguages = _useState4[0],
    setAvailableLanguages = _useState4[1];
  useEffect(function () {
    setAvailableLanguages(getAvailableLangs());
  }, [getAvailableLangs]);
  var onToggleDropdown = function onToggleDropdown(open, event) {
    if ((event === null || event === void 0 ? void 0 : event.source) === 'rootClose') {
      setDropdowns({});
    } else {
      toggleDropdown(DROPDOWN_KEY, open);
    }
  };
  var toggleDropdown = function toggleDropdown(key, open) {
    setDropdowns(_defineProperty({}, key, open));
  };
  var setUrlParameter = function setUrlParameter(url, setkey, setvalue) {
    var key = encodeURIComponent(setkey);
    var value = encodeURIComponent(setvalue);
    var baseUrl = url.split('?')[0];
    var newParam = "".concat(key, "=").concat(value);
    var params = "?".concat(newParam);
    var urlQueryString = url.split('?')[1] === undefined ? '' : "?".concat(url.split('?')[1]);

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
      var updateRegex = new RegExp('([?&])' + key + '=[^&]*');
      var removeRegex = new RegExp('([?&])' + key + '=[^&;]+[&;]?');
      if (!value || value === '') {
        // Remove param if value is empty
        params = urlQueryString.replace(removeRegex, '$1');
        params = params.replace(/[&;]$/, '');
      } else if (urlQueryString.match(updateRegex) !== null) {
        // If param exists already, update it
        params = urlQueryString.replace(updateRegex, '$1' + newParam);
      } else if (urlQueryString === '') {
        // If there are no query strings
        params = "?".concat(newParam);
      } else {
        // Otherwise, add it to end of query string
        params = "".concat(urlQueryString, "&").concat(newParam);
      }
    }
    params = params === '?' ? '' : params;
    return "".concat(baseUrl).concat(params);
  };
  var changeLanguage = function changeLanguage(lang) {
    var windowHelper = WindowHelperWrapper(window);
    if (reloadType === 'query') {
      if (lang.abbr === locale) return;
      var cleanedBaseUrl = window.location.pathname.replace(/\#$/, '');
      var urlWithParams = setUrlParameter(cleanedBaseUrl, 'locale', lang.abbr);
      windowHelper.redirect(urlWithParams);
    } else if (reloadType === 'inline') {
      var _window$location$href = window.location.href.split('.net/'),
        _window$location$href2 = _slicedToArray(_window$location$href, 2),
        domain = _window$location$href2[0],
        path = _window$location$href2[1];
      var _path$split = path.split('/'),
        _path$split2 = _slicedToArray(_path$split, 1),
        langPathSegment = _path$split2[0];
      if ((langPathSegment === null || langPathSegment === void 0 ? void 0 : langPathSegment.length) !== 2) {
        // no lang, need to add it
        windowHelper.redirect("".concat(domain, ".net/").concat(lang.abbr, "/").concat(path));
      }

      // we have a lang in there
      if (lang.abbr !== langPathSegment) {
        var replacedLangPath = window.location.pathname.replace(/\/[a-z]{2}\//, lang.abbr);
        windowHelper.redirect(replacedLangPath);
      }
    }
  };
  var renderDropdownMenuItems = function renderDropdownMenuItems() {
    return availableLanguages.map(function (item, subKey) {
      return /*#__PURE__*/React.createElement(Dropdown.Item, {
        key: subKey,
        id: "language-menu-".concat(subKey),
        onClick: function onClick() {
          return changeLanguage(item);
        }
      }, item.abbr === locale && /*#__PURE__*/React.createElement("span", {
        className: "selected-language-check",
        "aria-hidden": true
      }, /*#__PURE__*/React.createElement(FAIcon, {
        icon: "check"
      })), i18n.t(item.name));
    });
  };
  var dropdownProps = {
    id: 'language-dropdown',
    className: 'footer-language-dropup',
    onToggle: onToggleDropdown,
    open: dropdowns[DROPDOWN_KEY]
  };
  return /*#__PURE__*/React.createElement(Dropdown, dropdownProps, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "default"
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: "language"
  }), /*#__PURE__*/React.createElement("span", null, i18n.t('Language'))), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "footer-language-dropup-menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mobile-close",
    "aria-label": i18n.t('Close'),
    onClick: function onClick() {
      return toggleDropdown(DROPDOWN_KEY, false);
    }
  }, "\xD7"), renderDropdownMenuItems()));
};
LanguageDropdown.displayName = "LanguageDropdown";
export { LanguageDropdown };